(function () {
  'use strict';

  function updateCartBadge(cart) {
    var badge = document.getElementById('ch-cart-count');
    if (badge && cart) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function defaultOption(opt, def) { return typeof opt === 'undefined' ? def : opt; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = formatString.match(placeholderRegex);
    if (!match) return cents;
    var value = '';
    switch (match[1]) {
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function changeLine(key, quantity, root, moneyFormat) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      })
      .then(function (cart) {
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }
        updateCartBadge(cart);
        refreshPageTotals(root, cart, moneyFormat);
        var line = root.querySelector('[data-cart-line="' + key + '"]');
        if (!line && quantity === 0) return cart;
        if (line) {
          if (quantity === 0) {
            line.remove();
          } else {
            var qtyEl = line.querySelector('[data-cart-qty-val]');
            var priceEl = line.querySelector('[data-cart-line-price]');
            var item = cart.items.find(function (i) { return i.key === key; });
            if (qtyEl) qtyEl.textContent = quantity;
            if (priceEl && item) priceEl.textContent = formatMoney(item.final_line_price, moneyFormat);
          }
        }
        var titleCount = root.querySelector('[data-cart-count-label]');
        if (titleCount) {
          var countTpl = root.getAttribute('data-cart-count-template') || '({{ count }} items)';
          titleCount.textContent = countTpl.replace('__COUNT__', String(cart.item_count)).replace('{{ count }}', String(cart.item_count));
        }
        return cart;
      });
  }

  function refreshPageTotals(root, cart, moneyFormat) {
    var subtotal = root.querySelector('[data-cart-subtotal]');
    var total = root.querySelector('[data-cart-total]');
    var stickyTotal = root.querySelector('[data-cart-sticky-total]');
    var checkoutButtons = root.querySelectorAll('[data-cart-checkout]');
    var formattedTotal = formatMoney(cart.total_price, moneyFormat);
    if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price, moneyFormat);
    if (total) total.textContent = formattedTotal;
    if (stickyTotal) stickyTotal.textContent = formattedTotal;
    var checkoutTpl = root.getAttribute('data-checkout-template') || 'Checkout · __PRICE__';
    checkoutButtons.forEach(function (btn) {
      btn.textContent = checkoutTpl.replace('__PRICE__', formattedTotal);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-lyy-cart-page]');
    if (!root) return;
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    root.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.lineKey;
        var valEl = root.querySelector('[data-cart-qty-val][data-line-key="' + key + '"]');
        var qty = Math.max(0, (parseInt(valEl.textContent, 10) || 1) - 1);
        changeLine(key, qty, root, moneyFormat).catch(function () { alert('Could not update cart.'); });
      });
    });

    root.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.lineKey;
        var valEl = root.querySelector('[data-cart-qty-val][data-line-key="' + key + '"]');
        var qty = (parseInt(valEl.textContent, 10) || 1) + 1;
        changeLine(key, qty, root, moneyFormat).catch(function () { alert('Could not update cart.'); });
      });
    });

    root.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.lineKey;
        changeLine(key, 0, root, moneyFormat).catch(function () { alert('Could not remove item.'); });
      });
    });

    var voucherBtn = root.querySelector('[data-cart-voucher-apply]');
    var voucherInput = root.querySelector('[data-cart-voucher-input]');
    if (voucherBtn && voucherInput) {
      voucherBtn.addEventListener('click', function () {
        var code = voucherInput.value.trim();
        if (!code) return;
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      });
    }
  });
})();
